import { RequireOnly } from '@pelicargo/types';
import { AircraftType, FlightSegment } from '@prisma/client';

// Ordered from most constraining to least constraining
export const aircraftTypeByConstraint = [
  AircraftType.NarrowBody,
  AircraftType.WideBody,
  AircraftType.Freighter,
  AircraftType.RFS,
] as const;

export const mostConstrainingLeg = <T extends RequireOnly<FlightSegment, 'aircraft_type'>>(flightSegments: T[]) => {
  // Return the most constraining flight segment from the given flight segments

  // Slice makes a copy of flightSegments to not mutate the original array
  const sortedByConstraint = [...flightSegments].sort((a, b) => {
    if (!a?.aircraft_type) return 1;
    if (!b?.aircraft_type) return -1;

    return aircraftTypeByConstraint.indexOf(a?.aircraft_type) - aircraftTypeByConstraint.indexOf(b?.aircraft_type);
  });

  // Return the most constraining aircraft type from the given flight segments
  return sortedByConstraint?.[0];
};
